import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=0f15960c"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports